@if(isDisabled){
<app-loader></app-loader>
}
<form name="RouteForm" (ngSubmit)="RouteForm.form.valid && Save()" #RouteForm="ngForm">
    <div class="card">
        <div class="card-header">
            Attendance
        </div>
        <div class="card-body" style="overflow: auto; height: 450px;width: 100%;">
            <div class="row px-2">
                <div class="col-md mx-1 px-1 bghighlight">
                    <!-- <label class="text-label">Employee</label><br /> -->
                    <label class="Label1">
                        <div class="row no-gutters cursor-pointer" style="align-items: center;width: 300px;">
                            <div class="col-2">
                                <img *ngIf="InputData.Photo != null && InputData.Photo != ''" mat-card-image
                                    class="userImage" [src]="common.PhotoLink(InputData.Photo)" />
                                <div *ngIf="InputData.Photo == null || InputData.Photo == ''" class="initial-image">
                                    <div class="image">
                                        {{common.getInitial(InputData.EmpName)}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-9 userdetail">
                                <span class="text-label">{{InputData.EmpName}}</span><br />
                                <span class="text-label-light">#{{InputData.Empcode}}</span><br />
                                <span class="text-label-light">{{InputData.DesignationName}}</span>
                            </div>
                        </div>
                    </label>
                </div>
            </div>

            <div class="mt-3">
                <div class="row m-1">
                    <div class="col-md-1 px-1">
                        <label class="Label" for="SelectAttendanceType">Check </label>
                        <!-- <input type="checkbox" (click)="selectAttendanceType($event, Filter.SelectAttendanceType)"> -->
                    </div>
                    <div class="col-md-3 px-1">
                        <ng-select [items]="AttendanceRemarkLoad" bindLabel="AttendanceType"
                            bindValue="AttendanceTypeCode" placeholder="Select Attendance"
                            [(ngModel)]="Filter.SelectAttendanceType" name="SelectAttendanceType">
                        </ng-select>
                    </div>
                    <div class="col-md-1">
                        <button class="btn btn-primary btn-sm" type="button"
                            (click)="selectAttendanceType(Filter.SelectAttendanceType)">
                            Apply
                        </button>
                    </div>
                    <div class="col-md-1"></div>

                    <div class="col-md-1 px-1">
                        <label class="Label" for="MarkAttendanceType">Mark All</label>
                    </div>
                    <div class="col-md-3 px-1">
                        <ng-select [items]="AttendanceRemarkLoad" bindLabel="AttendanceType"
                            bindValue="AttendanceTypeCode" placeholder="Mark Attendance"
                            [(ngModel)]="Filter.MarkAttendanceType" name="MarkAttendanceType">
                        </ng-select>
                    </div>
                    <div class="col-md-1">
                        <button type="button" (click)="markAttendanceType(Filter.MarkAttendanceType)"
                            class="btn btn-primary btn-sm">
                            Apply
                        </button>
                    </div>
                    <!-- <div class="col-md-1">
                    <button class="btn btn-primary btn-sm">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled?'Apply ':'Loading...'}}
                    </button>
                </div> -->
                </div>
                <div class="row mt-2 m-1">
                    <div class="col-md-1 px-1">
                        <label class="Label" for="MarkShift">Shift for All</label>
                    </div>
                    <div class="col-md-3 px-1">
                        <ng-select [items]="ShiftLoad" bindLabel="ShiftTitle" bindValue="ShiftMasterID"
                            placeholder="Select Shift for all" [(ngModel)]="Filter.MarkShift" name="MarkShift">
                        </ng-select>
                    </div>

                    <div class="col-md-1">
                        <button type="button" (click)="markShift(Filter.MarkShift)"
                            class="btn btn-primary btn-sm">Apply</button>
                    </div>

                    <div class="col-md-1"></div>

                    <div class="col-md-1 px-1">
                        <label class="Label" for="MarkDuty">Duty for All</label>
                    </div>
                    <div class="col-md-3 px-1">
                        <ng-select [items]="DutyLoad" bindLabel="DutyName" bindValue="DutyMasterID"
                            placeholder="Select Duty for all" [(ngModel)]="Filter.MarkDuty" name="MarkDuty">
                        </ng-select>
                    </div>
                    <div class="col-md-1">
                        <button type="button" (click)="markDuty(Filter.MarkDuty)"
                            class="btn btn-primary btn-sm">Apply</button>
                    </div>
                </div>
                <div class="row mt-2 m-1">
                    <div class="col-md-1 px-1">
                        <label class="Label">Designation</label>
                    </div>
                    <div class="col-md-3 px-1">
                        <ng-select [items]="DesignationLoad" bindLabel="DesignationName" bindValue="DesignationMasterID"
                            placeholder="Select Designation for all" [(ngModel)]="Filter.MarkDesignation"
                            name="MarkDesignation">
                        </ng-select>
                    </div>
                    <div class="col-md-1">
                        <button type="button" (click)="markDesignation(Filter.MarkDesignation)"
                            class="btn btn-primary btn-sm">Apply</button>
                    </div>
                    <div class="col-md-1"></div>
                    <div *ngIf="InputData.EMPTYPE == 'FRONT'" class="col-md-auto">
                        <button (click)="ViewDesignationDuty()" type="button"
                            class="btn btn-outline-primary btn-sm me-1" [disabled]="isDisabled" container="body"
                            placement="top">
                            Designation Duty Combo
                            <span *ngIf="isDisabled" class="spinner-border spinner-border-sm" role="status"
                                aria-hidden="true"></span>
                        </button>
                    </div>
                </div>
            </div>
            <hr>

            <div class="mt-3">
                <table datatable [dtOptions]="dtoptions" [dtTrigger]="dtTrigger" class="table table-bordered pt-2"
                    style="width: 100%; overflow: auto;">
                    <thead class="table-light">
                        <tr>
                            <!-- <th style="width: 5px;">#</th> -->
                            <th scope="col" style="width: 5px;">
                                <input type="checkbox" name="all" (change)="selectAll($event)" [(ngModel)]="allSelect">
                            </th>
                            <!-- <th>Employee</th> -->
                            <th style="width: 80px;">Date</th>
                            <th style="width: 100px;">Attendance Remark</th>
                            <th>Designation</th>
                            <th>Duty</th>
                            <th>Shift</th>
                            <th>In Time</th>
                            <th>Out Time</th>
                            <th style="width: 200px;">Site Name</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr style="font-size: 11px;" *ngFor="let TableData of TableDatas; let i = index">
                            <!-- <th scope="row">{{ i + 1 }}</th> -->
                            <td>
                                <input type="checkbox" [(ngModel)]="TableData.selected" name="row{{i}}"
                                    (change)="selectRow($event, TableData); resetSelection()"
                                    (click)="resetSelection()">
                            </td>
                            <!-- <td>
                            <div class="row no-gutters cursor-pointer" style="align-items: center;width: 300px;">
                                <div class="col-2">
                                    <img *ngIf="TableData['Photo'] != null && TableData['Photo'] != ''" mat-card-image
                                        class="userImage" [src]="common.PhotoLink(TableData['Photo'])" />
                                    <div *ngIf="TableData['Photo'] == null || TableData['Photo'] == ''"
                                        class="initial-image">
                                        <div class="image">
                                            {{common.getInitial(TableData['EmployeeName'])}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-9 userdetail">
                                    <span class="text-label">{{TableData['EmployeeName']}}</span><br />
                                    <span class="text-label-light">#{{TableData['EmpCode']}}</span><br />
                                    <span class="text-label-light">{{TableData['DesignationName']}}</span>
                                </div>
                            </div>
                        </td> -->
                            <td>
                                <div style="width: 70px;">
                                    {{TableData['AttendanceDate']}}
                                </div>
                            </td>
                            <td>
                                <!-- <div style="width: 90px;"> -->
                                <!-- <ng-select dropdownPosition="bottom" name="attendance{{i}}"
                                    [items]="AttendanceRemarkLoad" bindLabel="AttendanceType"
                                    bindValue="AttendanceTypeCode" [(ngModel)]="TableData.AttendanceRemark"
                                    placeholder=" " [disabled]="!TableData.selected" [clearable]="false" required>
                                </ng-select> -->
                                <select class="form-control" name="attendance{{i}}"
                                    [(ngModel)]="TableData.AttendanceRemark" [disabled]="!TableData.selected" required>

                                    <!-- <option value="" disabled selected hidden> </option> -->

                                    <option *ngFor="let item of AttendanceRemarkLoad" [value]="item.AttendanceTypeCode">
                                        {{ item.AttendanceType }}
                                    </option>

                                </select>
                                <div class="invalid-feedback">
                                    Please select Attendance
                                </div>
                                <!-- </div> -->
                            </td>
                            <td>
                                <!-- <div style="width: 100px;"> -->
                                <!-- <ng-select dropdownPosition="bottom" name="designation{{i}}" [items]="DesignationLoad" bindLabel="DesignationName"
                                    bindValue="DesignationMasterID" [(ngModel)]="TableData.DesignationID"
                                    placeholder=" " [disabled]="!TableData.selected" [clearable]="false" required>
                                </ng-select> -->
                                <select class="form-select" name="designation{{i}}"
                                    [(ngModel)]="TableData.DesignationID" [disabled]="!TableData.selected" required>
                                    <!-- <option value="" disabled selected hidden></option> -->
                                    <option *ngFor="let designation of DesignationLoad"
                                        [value]="designation.DesignationMasterID">
                                        {{ designation.DesignationName }}
                                    </option>
                                </select>
                                <div class="invalid-feedback">
                                    Please select Designation.
                                </div>
                                <!-- </div> -->
                            </td>
                            <td>
                                <!-- <div style="width: 120px;"> -->
                                <!-- <ng-select dropdownPosition="bottom" name="duty{{i}}" [items]="DutyLoad"
                                    bindLabel="DutyName" bindValue="DutyMasterID" [(ngModel)]="TableData.DutyID"
                                    placeholder=" " [disabled]="!TableData.selected" [clearable]="false" required>
                                </ng-select> -->
                                <select class="form-select" name="duty{{i}}" [(ngModel)]="TableData.DutyID"
                                    [disabled]="!TableData.selected" required>
                                    <!-- <option value="" disabled selected hidden></option> -->
                                    <option *ngFor="let duty of DutyLoad" [value]="duty.DutyMasterID">
                                        {{ duty.DutyName }}
                                    </option>
                                </select>
                                <div class="invalid-feedback">
                                    Please select Duty.
                                </div>
                                <!-- </div> -->
                            </td>
                            <td>
                                <!-- <div style="width: 130px;"> -->
                                <!-- <ng-select dropdownPosition="bottom" name="shift{{i}}" [items]="ShiftLoad"
                                    bindLabel="ShiftTitle" bindValue="ShiftMasterID" [(ngModel)]="TableData.ShiftID"
                                    placeholder=" " [disabled]="!TableData.selected" [clearable]="false" required>
                                </ng-select> -->
                                <select class="form-select" name="shift{{i}}" [(ngModel)]="TableData.ShiftID"
                                    [disabled]="!TableData.selected" required>
                                    <!-- <option value="" disabled selected hidden></option> -->
                                    <option *ngFor="let shift of ShiftLoad" [value]="shift.ShiftMasterID">
                                        {{ shift.ShiftTitle }}
                                    </option>
                                </select>
                                <div class="invalid-feedback">
                                    Please select Shift.
                                </div>
                                <!-- </div> -->
                            </td>
                            <!-- <td>{{TableData['InTime']}}</td>
                        <td>{{TableData['OutTime']}}</td> -->

                            <td>
                                <div class="row no-gutters cursor-pointer" style="align-items: center;width: 150px;">
                                    <div class="col-4">
                                        <img *ngIf="TableData['DailyAttendancePhoto'] != null && TableData['DailyAttendancePhoto'] != ''"
                                            mat-card-image class="userImage"
                                            [src]="common.PhotoLink(TableData['DailyAttendancePhoto'])" />
                                        <div *ngIf="TableData['DailyAttendancePhoto'] == null || TableData['DailyAttendancePhoto'] == ''"
                                            class="initial-image">
                                            <div class="image">
                                                {{common.getInitial(TableData['EmployeeName'])}}
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <br> -->
                                    <!-- <span class="text-label">{{TableData['InTime']}}</span> -->
                                    <div class="col-8">
                                        <span class="text-label">{{TableData['InTime']}}</span>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div class="row no-gutters cursor-pointer" style="align-items: center;width: 150px;">
                                    <div class="col-4">
                                        <img *ngIf="TableData['DailyAttendancePhotoOut'] != null && TableData['DailyAttendancePhotoOut'] != ''"
                                            mat-card-image class="userImage"
                                            [src]="common.PhotoLink(TableData['DailyAttendancePhotoOut'])" />
                                        <div *ngIf="TableData['DailyAttendancePhotoOut'] == null || TableData['DailyAttendancePhotoOut'] == ''"
                                            class="initial-image">
                                            <div class="image">
                                                {{common.getInitial(TableData['EmployeeName'])}}
                                            </div>
                                        </div>
                                    </div><br />
                                    <div class="col-8">
                                        <span class="text-label">{{TableData['OutTime']}}</span>
                                    </div>
                                </div>
                            </td>
                            <td>
                                {{TableData['SiteName']}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col">
                </div>
                <div class="col-auto">
                    <div class="col-auto">
                        <button type="button" class="btn btn-outline-primary btn-sm me-1" (click)="close()"
                            [disabled]="isDisabled" ngbTooltip="Cancel" container="body" placement="top">
                            Cancel
                            <span *ngIf="isDisabled" class="spinner-border spinner-border-sm" role="status"
                                aria-hidden="true"></span>
                        </button>

                        <button type="submit" class="btn btn-primary btn-sm" [disabled]="isDisabled"><i
                                class="bi bi-save2" *ngIf="!isDisabled"></i>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                *ngIf="isDisabled"></span>
                            {{!isDisabled?'Save':'Loading...'}}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>